import isSafari from "../../../utils/isSafari";

export default () => ({
    project: null,
    requestedAbsoluteTime: 0,
    currentVideoAbsoluteTime: 0,
    isPaused: true,
    isFullScreen: false,
    volume: 0.5,
    isMuted: isSafari(),
    hasEverPlayed: false,
    expandedAllClips: false,
    clipRanges: {},
});